export const iconFontAwesomeAlphabetC = (
	<i className="fa-solid fa-c"></i>
);
